<template>
  <button :disabled="disabled" :class="['button-component', ...buttonClasses]">
    <slot name="prepend" />
    <slot />
    <slot name="append" />
  </button>
</template>

<script>
export default {
  name: "ButtonComponent",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    kind: {
      type: String,
      required: false,
      default: "primary",
      validator: (kind) => {
        return (
          ["primary", "secondary", "tertiary", "danger", "link", "success"].indexOf(kind) >
          -1
        );
      },
    },
  },
  computed: {
    buttonClasses() {
      let list = [];
      if (this.kind) {
        list.push(`button-component_${this.kind}`);
      }
      return list;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.button-component {
  padding: 14px 32px;
  border-radius: 32px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid transparent;
  box-sizing: border-box;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  font-weight: 600;
  &:disabled {
    background-color: #f5f5fa;
    color: $gray-dark;
    border-color: $gray-light1;
    &:hover {
      background-color: $gray-light1 !important;
      color: $gray-dark !important;
      border-color: $gray-light1 !important;
    }
  }

  &_primary {
    color: $white;
    background-color: $blue-light;
    border-color: $blue-light;
    &:hover {
      color: $white;
      background-color: $blue;
      border-color: $blue;
    }
  }
  &_secondary {
    color: $blue-light;
    background-color: transparent;
    border-color: $blue-light;
    &:hover {
      color: $blue;
      background-color: transparent;
      border-color: $blue;
    }
  }
  &_tertiary {
    color: $blue-light;
    background-color: transparent;
    border-color: transparent;
    &:hover {
      color: $blue;
      background-color: transparent;
      border-color: transparent;
    }
  }
  &_success {
    color: $white;
    background-color: $green-light;
    border-color: $green-light;
    &:hover {
      color: $white;
      background-color: $green-dark;
      border-color: $green-dark;
    }
  }
}
@media (max-width: 1440px) {
  .button-component {
    // width: 100%;
    max-width: 100%;
    // justify-content: center;
    text-align: center;
    padding: 8px 16px;
    &.width-auto {
      width: auto;
    }
  }
}
</style>
